import Extension from "../base/extension";

class AsyncExamples extends Extension {
  static autoregister = false;

  onReady() {
    // console.log(`[A-E] ${new Date().getTime()} basicAsyncCall`);  
    // this.basicAsyncCall();

    // console.log(`[A-E] ${new Date().getTime()} basicPromise`);  
    // this.basicPromise();

    // console.log(`[A-E] ${new Date().getTime()} fetchAsyncCall`);
    // this.fetchAsyncCall();

    // console.log(`[A-E] ${new Date().getTime()} fetchPromise`);
    // this.fetchPromise();

    // console.log(`[A-E] ${new Date().getTime()} rejectedAsyncCall`);
    // this.rejectedAsyncCall();

    // console.log(`[A-E] ${new Date().getTime()} rejectedPromise`);
    // this.rejectedPromise();

    // console.log(`[A-E] ${new Date().getTime()} nestedPromises`);
    // this.nestedPromises();

    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall`);
    this.nonNestedAsyncCall(); 
  }

  /**
   * Create a promise that resolves after 2 seconds, printing a message to the 
   * console.
   * 
   * @returns {Promise}
   */
  resolveAfter2Seconds() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(`[A-E] ${new Date().getTime()} Resolved after 2 seconds`);
      }, 2000);
    });
  }

  /**
   * Create a promise that rejects after 2 seconds, printing a message to the 
   * console.
   * 
   * @returns {Promise}
   */
  rejectAfter2Seconds() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(`[A-E] ${new Date().getTime()} Rejected after 2 seconds`);
      }, 2000);
    });
  }
  
  /**
   * Basic async call. Note the 'async function', and the await keyword.
   * If a function uses the await keyword, it must be declared as async.
   * If you don't have the async keyword, you'll get an error:
   * "Cannot use keyword 'await' outside an async function". This is 
   * functionally the same as the promise.
   */
  async basicAsyncCall() {
    console.log(`[A-E] ${new Date().getTime()} Basic async call`);

    const result = await this.resolveAfter2Seconds();
    console.log(result);
  }

  /**
   * Basic promise. Note the .then() method, rather than async / await.
   * This is the 'old' way of doing things, but still useful to know. This is
   * functionally the same as the async call.
   */
  basicPromise() {
    console.log(`[A-E] ${new Date().getTime()} Basic promise`);

    this.resolveAfter2Seconds().then(result => {
      console.log(result);
    });
  }

  /**
   * Fetch async call. Note the 'async function', and the await keyword. Using
   * this syntax avoids 'callback hell', where you have to nest callbacks inside
   * callbacks inside callbacks. This is functionally the same as the promise.
   */
  async fetchAsyncCall() {
    console.log(`[A-E] ${new Date().getTime()} Fetch async call`);

    const response = await fetch('https://jsonplaceholder.typicode.com/todos/1');
    const json = await response.json();
    console.log(`[A-E] ${new Date().getTime()} Fetch async call:`, json);
  }

  /**
   * Fetch promise. Note the .then() method, rather than async / await. Note
   * we have to chain multiple 'then' methods together, which can get messy.
   * This is functionally the same as the async call.
   */
  fetchPromise() {
    console.log(`[A-E] ${new Date().getTime()} Fetch promise`);
    fetch('https://jsonplaceholder.typicode.com/todos/2')
      .then(response => response.json())
      .then(json => console.log(`[A-E] ${new Date().getTime()} Fetch promise:`, json));
  }

  /**
   * Rejected async call. Note the 'async function', and the await keyword. Note
   * the try / catch block, which is used to catch errors. This is functionally
   * the same as the rejectedPromise example.
   */
  async rejectedAsyncCall() {
    try {
      // This will never run, as the promise always rejects.
      const result = await this.rejectAfter2Seconds();
      console.log(result);
    } catch (error) {
      // This will log, as a rejected promise is caught.
      console.error(error);
    }
  }

  /**
   * Rejected promise. Note the .catch() method, which is called when the
   * promise is rejected, and the .finally() method, which is called after all
   * other handlers have completed.
   */
  rejectedPromise() {
    this.rejectAfter2Seconds().then(result => {
      // This will never run, as the promise always rejects.
      console.log(result);
    }).catch(error => {
      // This will log, as the promise is rejected.
      console.error(error);
    }).finally(() => {
      // This will log, as finally is always called.
      console.log(`[A-E] ${new Date().getTime()} Finally - runs after everything else`);
    });
  }

  /**
   * nonNestedAsyncCall. Note the 'async function', and the await keyword. Note
   * there's no nesting compared to the nestedPromises example.
   */
  async nonNestedAsyncCall() {
    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall call`);

    let response = await fetch('https://jsonplaceholder.typicode.com/todos/6');
    let json = await response.json();
    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall (1st fetch):`, json)

    response = await fetch('https://jsonplaceholder.typicode.com/todos/7');
    json = await response.json();
    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall (2nd fetch):`, json)

    response = await fetch('https://jsonplaceholder.typicode.com/todos/8');
    json = await response.json();
    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall (3rd fetch):`, json);

    console.log(`[A-E] ${new Date().getTime()} nonNestedAsyncCall (equivalent to finally)`);
  }

  /**
   * nestedPromises. Note the .then() method, rather than async / await. Note
   * the nesting, which can get messy. This is functionally the same as the
   * nonNestedAsyncCall example.
   */
  nestedPromises() {
    console.log(`[A-E] ${new Date().getTime()} nestedPromises call`);

    fetch('https://jsonplaceholder.typicode.com/todos/3')
      .then(response => response.json())
      .then(json => {
        console.log(`[A-E] ${new Date().getTime()} nestedPromises (1st fetch):`, json)
      }).then(() => {
        fetch('https://jsonplaceholder.typicode.com/todos/4')
          .then(response => response.json())
          .then(json => {
            console.log(`[A-E] ${new Date().getTime()} nestedPromises (2nd fetch):`, json)
          }).then(() => {
            fetch('https://jsonplaceholder.typicode.com/todos/5')
              .then(response => response.json())
              .then(json => {
                console.log(`[A-E] ${new Date().getTime()} nestedPromises (3rd fetch):`, json)
              }).finally(() => {
                console.log(`[A-E] ${new Date().getTime()} nestedPromises (finally)`);
              });
          });
      });
  }
}

export default AsyncExamples;